// reactstrap components
import {
  Badge,
  Card,
  CardHeader,
  Container,
  Row,
  Input,
} from "reactstrap";

import { useState, useEffect } from "react";
import Header from "components/Headers/Header.js";
import { toast } from "react-toastify";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { DataTable, FilterBar, TablePagination } from "components/shared";

import { getApiDataService } from "../../services/apiServices";
import { POINT_TRANSACTION_API } from "../../services/CONSTANTS";

import styles from "./ImageUpload.module.css";

const POINT_COLUMNS = [
  { key: "index", label: "#" },
  { key: "amount", label: "Amount" },
  { key: "userCode", label: "UserCode" },
  { key: "state", label: "State" },
  { key: "remark", label: "Remark" },
  { key: "title", label: "Transaction Title" },
  { key: "created", label: "Created At" },
];

const PointTransactionList = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [searchCode, setSearchCode] = useState("");

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [page, setPage] = useState(1);
  const [perPage] = useState(10);
  const [meta, setMeta] = useState({});

  let api = POINT_TRANSACTION_API + `?page=${page}&perPage=${perPage}`;
  api += searchCode ? `&userCode=${searchCode}` : "";
  api += startDate ? `&startDate=${startDate}` : "";
  api += endDate ? `&endDate=${endDate}` : "";

  useEffect(() => {
    fetchData();
  }, [page, searchCode, startDate, endDate]);

  const fetchData = () => {
    setIsLoading(true);
    getApiDataService(api)
      .then((res) => {
        setData(res.data || []);
        setMeta(res.meta || {});
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("Error Loading Data:", err);
        setIsLoading(false);
        setData([]);
      });
  };

  const handleDate = (start, end) => {
    setStartDate(new Date(start).toLocaleDateString("fr-CA"));
    setEndDate(new Date(end).toLocaleDateString("fr-CA"));
  };

  const handleReset = () => {
    setSearchCode("");
    setStartDate(null);
    setEndDate(null);
  };

  const isFiltering = () => {
    return searchCode || startDate || endDate;
  };

  return (
    <>
      <Header />

      <Container className="mt--7 akh-page-content" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <FilterBar
                  title="Point Transaction Records"
                  onClear={handleReset}
                  isFiltering={isFiltering()}
                >
                  <DateRangePicker onCallback={handleDate}>
                    <input
                      className="form-control akh-filter-width"
                      placeholder="Select date range"
                      aria-label="Date range"
                    />
                  </DateRangePicker>

                  <Input
                    className="akh-filter-width"
                    type="text"
                    placeholder="User Code"
                    aria-label="Search by user code"
                    value={searchCode}
                    onChange={(e) => setSearchCode(e.target.value)}
                  />
                </FilterBar>
              </CardHeader>

              <DataTable
                className="table-striped"
                columns={POINT_COLUMNS}
                data={data}
                isLoading={isLoading}
                emptyMessage="No records found"
                renderRow={(item, index) => (
                  <tr key={item?.id || index}>
                    <td>{index + 1}</td>
                    <td className="font-mono">{item?.amount} POINT</td>
                    <td>
                      <span
                        className={styles.copyText}
                        onClick={() => {
                          navigator.clipboard.writeText(item?.userCode);
                          toast.success("UserID Copied");
                        }}
                      >
                        {item?.name}{" "}
                        <Badge color="primary" pill className="font-mono">
                          {item?.userCode}
                        </Badge>
                      </span>
                    </td>
                    <td>
                      <Badge
                        color={
                          item?.state === "increase" ? "success" : "danger"
                        }
                        pill
                      >
                        {item?.state}
                      </Badge>
                    </td>
                    <td>{item?.remark}</td>
                    <td>{item?.transaction_title?.name}</td>
                    <td>{new Date(item?.createdAt).toLocaleString()}</td>
                  </tr>
                )}
              />

              <TablePagination meta={meta} page={page} setPage={setPage} />
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default PointTransactionList;
